<template>
  <div id="app">
    <div v-if="isIframeVisible" class="iframe-container">
      <div
        @click="closeIframe"
        style="
          margin-left: auto;
          width: fit-content;
          cursor: pointer;
          position: fixed;
          bottom: 10px;
          left: 10px;
        "
      >
        <svg
          width="74"
          height="76"
          viewBox="0 0 74 76"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_801_421)">
            <circle cx="38" cy="38" r="28" fill="#ff4d4f" />
          </g>
          <path
            d="M45 38H31M31 38L36.25 33M31 38L36.25 43"
            stroke="#EAEAEA"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <defs>
            <filter
              id="filter0_d_801_421"
              x="0"
              y="0"
              width="76"
              height="76"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_801_421"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_801_421"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
      <iframe
        ref="iframe"
        :src="iframeUrl"
        frameborder="0"
        class="full-iframe"
        sandbox="allow-modals allow-same-origin allow-scripts allow-forms allow-popups allow-top-navigation allow-top-navigation-by-user-activation allow-popups-to-escape-sandbox"
        allow="clipboard-write; encrypted-media; fullscreen; geolocation; microphone; camera"
      ></iframe>
    </div>
    <div v-else>
      <!-- Existing app content -->
      <router-view />
      <!-- <div
		id="custom-splash"
		style="
		  position: fixed;
		  top: 0;
		  left: 0;
		  width: 100%;
		  height: 100%;
		  background-color: #fecc00;
		  display: flex;
		  align-items: center;
		  justify-content: center;
		"
	  >
		<img
		  src="../public/img/icons/android-chrome-512x512.png"
		  alt="Logo"
		  style="width: 128px; height: 128px"
		/>
	  </div> -->
    </div>
  </div>
</template>
<script>
// window.addEventListener("load", function () {
//   const splash = document.getElementById("custom-splash");
//   splash.style.display = "none";
// });
export default {
  name: "App",
  provide() {
    return {
      openIframe: this.openIframe,
    };
  },
  data() {
    return {
      isIframeVisible: false,
      iframeUrl: "",
    };
  },
  mounted() {
    this.addIframeClickListener();
    // Przywrócenie iframe z localStorage po odświeżeniu
    const savedIframeUrl = localStorage.getItem("iframeUrl");
    if (savedIframeUrl) {
      this.iframeUrl = savedIframeUrl;
      this.isIframeVisible = true;
    }
  },
  methods: {
    openIframe(url) {
      this.iframeUrl = url;
      this.isIframeVisible = true;
      sessionStorage.setItem("iframeUrl", url);
    },
    closeIframe() {
      this.isIframeVisible = false;
      this.iframeUrl = "";
      sessionStorage.removeItem("iframeUrl");
    },
    addIframeClickListener() {
      const iframe = this.$refs.iframe;
      if (iframe) {
        iframe.addEventListener("load", () => {
          try {
            const iframeDocument =
              iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.addEventListener("click", (event) => {
              const target = event.target.closest("a");
              if (target && target.href) {
                event.preventDefault();
                this.openIframe(target.href);
              }
            });
          } catch (error) {
            console.warn(
              "Nie udało się przechwycić zdarzenia w iframe:",
              error
            );
          }
        });
      }
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap");
#app {
  font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
  font-style: normal;
}

.code-field__list {
  display: flex !important;
  gap: 10px;
  justify-content: center;
  align-items: center;
}

.code-field__input {
  height: 42px !important;
  max-width: 41px !important;
  margin: auto;
  text-align: center;
  border-radius: 6px;
  border: 1px solid #888888;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

body {
  background-color: #fff;
}

@media (prefers-color-scheme: dark) {
  body {
    background-color: #fff;
  }
}

/* Fullscreen iframe styles */
.iframe-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: white;
}

.full-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

/* Close button styles */
.close-button {
  position: absolute;
  bottom: 10px;
  left: 10px;
  width: 40px;
  height: 40px;
  background: #ff4d4f;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 18px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}
</style>
